<template>
  <div id="app" :class="$store.state.printingClass">
    <SimulationBanner v-if="$store.state.simulation.active" />
    <transition name="fade">
      <Alert
        v-if="$store.state.alert.active == true"
      />
    </transition>
    <router-view />
    <cookie-consent
      v-if="$store.state.display.fullscreen == false"
      id="cookieConsent"
    />
  </div>
</template>

<script>
import Alert from './components/Alert'
import SimulationBanner from './components/admin/SimulationBanner'

export default {
  components: {
    Alert,
    SimulationBanner
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
